import {
  Bag,
  ExpandOptions,
  getBagById,
  getCustomerBagByCountry,
} from "@repo/apis/bag";
import { is404Error } from "@repo/chameleon-request";
import { setBagCookies } from "../utils/bag-cookies";
import { handleApiInteractionError } from "../utils/handle-api-interaction-error";
import { BagSdkMethod } from "../utils/method-initialiser";

type PublicUpdateBagWithExpansionsMethod = (params: {
  expansions: ExpandOptions;
}) => Promise<Bag | null>;
type UpdateBagWithExpansionsMethod =
  BagSdkMethod<PublicUpdateBagWithExpansionsMethod>;

export const updateBagWithExpansionsInitialiser: UpdateBagWithExpansionsMethod =

    (context) =>
    async ({ expansions }) => {
      const {
        chameleonRequestInstance,
        store,
        lang,
        getAuthHeaderPredicate,
        customerId,
        keyStoreDataversion,
        country,
        state,
      } = context;

      const authHeader = await getAuthHeaderPredicate();
      const bag = state.getBag();

      try {
        const response = bag?.id
          ? await getBagById({
              chameleonRequestInstance,
              store,
              lang,
              bagId: bag.id,
              expand: expansions,
              authHeader,
            })
          : await getCustomerBagByCountry({
              chameleonRequestInstance,
              store,
              lang,
              customerId,
              country,
              keyStoreDataversion,
              authHeader,
              expand: expansions,
            });

        state?.setBag(response.data.bag);
        state?.setBagExpansions(expansions);
        state?.setBagSessionToken(response.bagSessionToken);

        setBagCookies(
          { store, country },
          {
            bagId: response.data.bag.id,
            bagOrigin: response.data.bag.origin,
            sessionToken: response.bagSessionToken,
          },
        );

        return response.data.bag;
      } catch (error: unknown) {
        if (is404Error(error)) {
          return null;
        }

        return handleApiInteractionError(error);
      }
    };
